// extracted by mini-css-extract-plugin
export default {"section":"ManageRoleLayout_section__gL1Fo","inputContainer":"ManageRoleLayout_inputContainer__z6Hd3","title":"ManageRoleLayout_title__MGPZX"};